import { render, staticRenderFns } from "./BackgroundImage.vue?vue&type=template&id=6c7b3f5e&scoped=true&"
import script from "./BackgroundImage.vue?vue&type=script&lang=ts&"
export * from "./BackgroundImage.vue?vue&type=script&lang=ts&"
import style0 from "./BackgroundImage.vue?vue&type=style&index=0&id=6c7b3f5e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c7b3f5e",
  null
  
)

export default component.exports